export const ordersTransitions = new Map<string, string[]>([
    ['unclaimed', ['claimed']]
]);

export const allOrderStates = ['unclaimed', 'claimed'];

export const bookingStatusOptionsGetter = (currentStatus: string): string[] => {
	return ordersTransitions.get(currentStatus) as string[];
}